import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ExternalResourcesPage } from "@/features/operator/ExternalResourcesPage";

export const Route = createFileRoute("/app/operator/external-resources")({
  validateSearch: z.object({
    tab: z.enum(["outbound", "rule_set", "subscriptions", "nodes"]).optional().catch(undefined),
  }),
  component: ExternalResourcesPage,
});
